<template>
  <a-modal
    title="配置产品可见内容"
    :visible="visible"
    :width="800"
    @ok="handleOk"
    @cancel="handleVisible"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="产品是否可见">
          <a-radio-group
            button-style="solid"
            v-decorator="[
              'isVisible',
              {
                initialValue: configureContent.fundIsVisible,
                rules: [
                  {
                    required: true,
                    message: '请选择产品是否可见'
                  }
                ]
              }
            ]"
            @change="visibleChange"
          >
            <a-radio-button :value="1"> 是 </a-radio-button>
            <a-radio-button :value="0"> 否</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="净值展示类型" v-if="!isExpected">
          <!-- <a-checkbox
            v-model="value"
            name="checkboxgroup"
            :options="figureArr"
            v-for="item in figureArr"
            :key="item.value"
            v-decorator="[
              'fundCode',
              {
                rules: [{ required: true, message: '请选择净值展示类型' }]
              }
            ]"
            @change="onChange"
          >
            {{ item.title }}
          </a-checkbox> -->
          <a-select
            style="width:290px"
            show-search
            mode="multiple"
            placeholder="请选择净值展示类型"
            :showSearch="true"
            optionFilterProp="label"
            v-decorator="[
              'netValueTypeIdList',
              {
                rules: [{ required: true, message: '请选择净值展示类型' }],
                getValueFromEvent: value => value.slice(0, 2)
              }
            ]"
          >
            <a-select-option
              :label="item.title"
              v-for="item in figureArr"
              :key="item.value"
            >
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          v-for="item in fundVisibleContentList"
          :key="item.visibleContentTitle"
          :label="item.visibleContentTitle"
        >
          <a-radio-group button-style="solid" v-model="item.visibleScope">
            <a-radio-button :value="0">所有人可见 </a-radio-button>
            <a-radio-button :value="1">仅持有人可见</a-radio-button>
            <a-radio-button :value="2">不可见</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <!-- <a-form-item label="产品公告是否可见">
        <a-radio-group default-value="1" button-style="solid">
          <a-radio-button value="1">所有人可见 </a-radio-button>
          <a-radio-button value="2"> 仅持有人可见</a-radio-button>
          <a-radio-button value="3"> 不可见</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="文件下载是否可见">
        <a-radio-group default-value="1" button-style="solid">
          <a-radio-button value="1">所有人可见 </a-radio-button>
          <a-radio-button value="2"> 仅持有人可见</a-radio-button>
          <a-radio-button value="3"> 不可见</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="投资经理是否可见">
        <a-radio-group default-value="1" button-style="solid">
          <a-radio-button value="1">所有人可见 </a-radio-button>
          <a-radio-button value="2"> 仅持有人可见</a-radio-button>
          <a-radio-button value="3"> 不可见</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="费率结构是否可见">
        <a-radio-group default-value="1" button-style="solid">
          <a-radio-button value="1">所有人可见 </a-radio-button>
          <a-radio-button value="2"> 仅持有人可见</a-radio-button>
          <a-radio-button value="3"> 不可见</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="代销渠道是否可见">
        <a-radio-group default-value="1" button-style="solid">
          <a-radio-button value="1">所有人可见 </a-radio-button>
          <a-radio-button value="2"> 仅持有人可见</a-radio-button>
          <a-radio-button value="3"> 不可见</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="收益率是否可见">
        <a-radio-group default-value="1" button-style="solid">
          <a-radio-button value="1">所有人可见 </a-radio-button>
          <a-radio-button value="2"> 仅持有人可见</a-radio-button>
          <a-radio-button value="3"> 不可见</a-radio-button>
        </a-radio-group>
      </a-form-item> -->
        <a-form-item label="图标" v-if="!hideSort">
          <a-radio-group
            default-value="无"
            button-style="solid"
            v-model="configureContent.icon"
          >
            <a-radio-button value="0">无</a-radio-button>
            <a-radio-button value="hot">hot</a-radio-button>
            <a-radio-button value="new">new</a-radio-button>
            <a-radio-button value="good">good</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="排序" v-if="!hideSort">
          <a-input-number
            :min="1"
            @change="onchange"
            v-model="configureContent.sort"
          ></a-input-number>
          <p style="color: rgba(239, 179, 65)">{{ msg }}</p>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
import {
  configureProductDisplay,
  judgeProductIndex,
  getProductVisibleContent,
  getBatchConfig,
  batchConfig
} from '@/api/product';
import Vue from 'vue';
import { ajaxGetDictItems } from '@/api/api';
export default {
  data() {
    return {
      figureArr: [],
      visible: false,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      fundCode: '',
      msg: '', //排序提示文案
      fundVisibleContentList: [
        {
          fundCode: null,
          visibleContent: '0',
          visibleScope: 0,
          visibleContentTitle: '代销渠道是否可见'
        },
        {
          fundCode: null,
          visibleContent: '1',
          visibleScope: 0,
          visibleContentTitle: '历史净值是否可见'
        },
        {
          fundCode: null,
          visibleContent: '2',
          visibleScope: 0,
          visibleContentTitle: '收益率是否可见'
        },
        {
          fundCode: null,
          visibleContent: '3',
          visibleScope: 0,
          visibleContentTitle: '投资经理是否可见'
        },
        {
          fundCode: null,
          visibleContent: '4',
          visibleScope: 0,
          visibleContentTitle: '产品公告是否可见'
        },
        {
          fundCode: null,
          visibleContent: '5',
          visibleScope: 0,
          visibleContentTitle: '文件下载是否可见'
        },
        {
          fundCode: null,
          visibleContent: '6',
          visibleScope: 0,
          visibleContentTitle: '费率结构是否可见'
        }
      ],
      configureContent: {
        fundIsVisible: 0,
        sort: 1,
        icon: '无'
      },
      isBath: false,
      hideSort: false,
      isExpected: false
    };
  },
  created() {
    this.getFigureList();
  },
  methods: {
    handelChange(value) {
      // debugger;
      const array = this.figureArr.filter(
        (item, index) => value.indexOf(index) === -1
      );
      if (value.length < 2) {
        this.figureArr.forEach((item, index, array) => {
          array.indexOf(item.id) == -1
            ? Vue.set(array[index], 'disabled', false)
            : '';
        });
      } else {
        let array1 = [];
        array.map(item => {
          array1.push(item.id);
        });
        this.figureArr.forEach((item, index, array) => {
          array1.indexOf(item.id) != -1
            ? Vue.set(array[index], 'disabled', true)
            : Vue.set(array[index], 'disabled', true);
        });
      }
    },
    getFigureList() {
      let code = 'net_value_type';
      ajaxGetDictItems(code).then(res => {
        if (res.success) {
          this.figureArr = res.result;
        }
      });
    },
    handleVisible(record) {
      console.warn(record);
      if (!record.fundCode) {
        this.hideSort = true;
      } else {
        this.hideSort = false;
      }
      if (record.isExpectedPro == 1) {
        this.isExpected = true;
      } else {
        this.isExpected = false;
      }
      this.visible = !this.visible;
      this.fundVisibleContentList.forEach(item => {
        item.fundCode = fundCode;
      });
    },
    initConfigure(fundCode) {
      this.fundCode = fundCode;
      this.isBath = false;
      this.confirmLoading = true;

      getProductVisibleContent(fundCode).then(res => {
        this.confirmLoading = false;
        if (res.success) {
          if (res.result.icon == null) {
            res.result.icon = '0';
          }
          console.warn(res.result.netValueTypeIdList);
          this.form.setFieldsValue({
            netValueTypeIdList: res.result.netValueTypeIdList,
            isVisible: res.result.fundIsVisible
          });
          this.configureContent = res.result
            ? {
                ...this.configureContent,
                ...res.result
                // sort: 1,
                // icon: '无'
              }
            : this.configureContent;
          if (res.result && res.result.fundVisibleContentList.length > 0) {
            let data = res.result.fundVisibleContentList;
            this.fundVisibleContentList = data;
          } else {
            this.initDictData();
          }
        } else {
          this.$message.error(res.success);
        }
      });
    },
    bathInitConfigure(ids) {
      this.confirmLoading = true;
      this.fundCode = ids;
      this.isBath = true;
      getBatchConfig().then(res => {
        this.confirmLoading = false;
        if (res.success) {
          if (res.result.icon == null) {
            res.result.icon = 0;
          }

          this.configureContent = res.result
            ? {
                ...this.configureContent,
                ...res.result,
                fundIsVisible: 0
                // sort: 1,
                // icon: '无'
              }
            : this.configureContent;

          if (res.result) {
            let data = res.result;

            this.fundVisibleContentList = data;
          }
        } else {
          this.$message.error(res.success);
        }
      });
    },

    handleOk() {
      this.form.validateFields((err, values) => {
        if (err) {
          return;
        }
        let params = {
          fundCode: this.fundCode,
          fundIsVisible: this.configureContent.fundIsVisible,
          sort: this.configureContent.sort,
          icon: this.configureContent.icon,
          netValueTypeIdList: this.form.getFieldValue('netValueTypeIdList')
        };
        // console.warn(this.form.getFieldValue('netValueTypeIdList'));
        let arr = [];
        this.fundVisibleContentList.forEach(item => {
          console.log(item);
          let obj = {
            visibleContent: item.visibleContent,
            visibleScope: item.visibleScope
          };
          arr.push(obj);
        });
        if (this.isBath) {
          params.visibleContentDTOList = arr;
        } else {
          params.fundVisibleContentOption = arr;
        }

        if (!this.isBath) {
          configureProductDisplay(params).then(res => {
            this.visible = false;
            if (res.success) {
              this.$message.success(res.message);
              this.$emit('callback');
              this.form.setFieldsValue({
                netValueTypeIdList: []
              });
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          params.fundCodes = this.fundCode;
          batchConfig(params).then(res => {
            this.visible = false;
            if (res.success) {
              this.$message.success(res.message);
              this.$emit('callback');
              this.form.setFieldsValue({
                netValueTypeIdList: []
              });
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    onchange(val) {
      let params = {
        fundCode: this.fundCode,
        index: val
      };
      judgeProductIndex(params).then(res => {
        if (!res.success) {
          this.msg = res.message;
        } else {
          this.msg = '';
        }
      });
    },
    visibleChange(val) {
      this.configureContent.fundIsVisible = val.target.value;
    },

    initDictData() {
      //根据字典Code, 初始化字典数组
      ajaxGetDictItems('product_content_is_visible', null).then(res => {
        if (res.success) {
          if (res.result && res.result.length > 0) {
            this.fundVisibleContentList = [];
            res.result.forEach(item => {
              this.fundVisibleContentList.push({
                fundCode: this.fundCode,
                visibleContent: item.value,
                visibleScope: 0,
                visibleContentTitle: item.title
              });
            });
          } else {
            this.fundVisibleContentList = [];
          }
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
/deep/.ant-checkbox-wrapper {
  width: 48%;
}
</style>
